
export class AbstractResource {
    constructor (client) {
        this.client = client;
        this.http = client.http;
    }
}